module.exports = __webpack_public_path__ + "static/img/19.3240491.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/19.png
// module id = nJmn
// module chunks = 2